import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Terms from './views/terms.vue'
import Numbers3 from './views/Numbers3.vue'
import Numbers4 from './views/Numbers4.vue'
import Loto6 from './views/Loto6.vue'
import Loto7 from './views/Loto7.vue'
import IxaHistory from './views/IxaHIstory.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: "IXA | Numbers3 Numbers4 LOTO6 LOTO7",
        description: "IXAは「ナンバーズ3、ナンバーズ4」や「ロト6、ロト7」をより楽しむ為の完全無料の選択数字ジェネレーターです。普段思いつかないような数字をランダムで生成し、購入予定数字の管理・記録も行えます。"
      }
    },
    {
      path: '/numbers3',
      name: 'numbers3',
      component: Numbers3,
      meta: {
        title: "IXA | ナンバーズ3 Numbers3",
        description: "ナンバーズ3 選択数字ジェネレーター。全部で1,000通りあります。1つずつ生成する機能と、100個ずつまとめて生成する機能があります。ピンと来た数字をクリック(タップ）し、その数字を日付とともに保存することも可能です。保存した数字は「History」ページで確認できます"
      }
    },
    {
      path: '/numbers4',
      name: 'numbers4',
      component: Numbers4,
      meta: {
        title: "IXA | ナンバーズ4 Numbers4",
        description: "ナンバーズ4 選択数字ジェネレーター。全部で10,000通りあります。1つずつ生成する機能と、1000個ずつまとめて生成する機能があります。ピンと来た数字をクリック(タップ）し、その数字を日付とともに保存することも可能です。保存した数字は「History」ページで確認できます"
      }
    },
    {
      path: '/loto6',
      name: 'loto6',
      component: Loto6,
      meta: {
        title: "IXA | ロト6 Loto6",
        description: "ナンバーズ3 選択数字ジェネレーター。全部で6,096,454通りあります。1つずつ生成する機能と、100個ずつまとめて生成する機能があります。ピンと来た数字をクリック(タップ）し、その数字を日付とともに保存することも可能です。保存した数字は「History」ページで確認できます"
      }
    },
    {
      path: '/loto7',
      name: 'loto7',
      component: Loto7,
      meta: {
        title: "IXA | ロト7 Loto7",
        description: "ナンバーズ3 選択数字ジェネレーター。全部で10,295,472通りあります。1つずつ生成する機能と、100個ずつまとめて生成する機能があります。ピンと来た数字をクリック(タップ）し、その数字を日付とともに保存することも可能です。保存した数字は「History」ページで確認できます"
      }
    },
    {
      path: '/history',
      name: 'history',
      component: IxaHistory,
      meta: {
        title: "IXA | 履歴 History",
        description: "保存した数字の履歴を確認できます。一括削除と選択削除機能もございますので、履歴が膨らんできたらご自由に管理してくださいね"
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        title: "IXA | 利用規約 Terms",
        description: "IXA 上の利用規約です。かたっ苦しい文書です。"
      }
    }
  ]
})
